var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":"","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({class:_vm.position == 'right' ? 'float-right' : '',attrs:{"color":_vm.color,"small":_vm.small}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},_vm._l((_vm.textArray),function(text){return _c('p',{key:text},[_vm._v(_vm._s(text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }